export default {
  hsmName: {
    value: '',
    required: true,
    state: null
  },
  hsmId: {
    value: '',
    required: true,
    state: null
  },
  hsmText: {
    value: '',
    maxlength: '160',
    required: true,
    state: null,
    rows: 7,
    size: 500
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/hsm/components/add/hsm-form.js